<template>
    <div class="center-page">
        <el-tabs v-model="activeName">
            <el-tab-pane label="个人资料" name="first">
                <el-form label-position="right" label-width="80px">
                    <el-form-item label="头像设置">
                        <el-avatar :size="60" :src="`/api/v1/file/${userForm.portrait}`"></el-avatar>
                        <el-link class="ml-20" style="line-height: 1.2;" type="primary" @click="selectFile">修改头像</el-link>
                    </el-form-item>
                    <el-form-item label="用户昵称">
                        <el-input style="width: 220px;" placeholder="情输入用户昵称" v-model="userForm.nickname"></el-input>
                    </el-form-item>
                    <el-form-item label="性别">
                        <el-select v-model="userForm.sex">
                            <el-option v-for="(item,index) in sexList" :key="index" :value="item.id" :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="证件认证">
                        <span>（可选）完成上传证件可以增加房客对您的信任感。东瀛民宿在任何时候都会对用户的身份隐私进行保护</span>
                        <el-button type="primary" class="ml-20" size="mini">立即认证</el-button>
                    </el-form-item>
                    <el-form-item label="个人介绍">
                        <el-input type="textarea" placeholder="情输入个人介绍" v-model="userForm.bio"></el-input>
                    </el-form-item>
                    <el-form-item label="出生日期">
                        <el-date-picker
                                v-model="userForm.birthday"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="所在国家">
                        <el-input style="width: 220px;" placeholder="情输入所在国家" v-model="userForm.country"></el-input>
                    </el-form-item>
                    <el-form-item label="所在地区">
                        <el-input style="width: 220px;" placeholder="情输入所在地区" v-model="userForm.city"></el-input>
                    </el-form-item>
                    <el-form-item label="语言">
                        <el-input style="width: 220px;" placeholder="情输入语言" v-model="userForm.language"></el-input>
                    </el-form-item>
                    <el-form-item label="电子邮箱">
                        <el-input style="width: 220px;" placeholder="情输入电子邮箱" v-model="userForm.mail"></el-input>
                    </el-form-item>
                    <el-form-item label="绑定手机">
                        <span>{{`${userForm.mobile.substr(0, 4)}***${userForm.mobile.substr(-4)}`}}</span>
                        <el-link class="ml-20" style="line-height: 1.2;" type="primary" @click="changePhone">更换手机</el-link>
                    </el-form-item>
                    <el-form-item label="">
                        <el-button type="primary" :loading="loading" @click="datumEdit">保存</el-button>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="收款方式" name="second">
                <el-button type="primary" @click="payAddShow">添加收款方式+</el-button>
                <el-table :data="payTypeList" border class="mt-20">
                    <el-table-column label="收款方式">
                        <template slot-scope="{row}">
                            <div class="table-row" v-if="row.mark === 0"><img src="./../../assets/img/pay1.png" alt="">银行卡</div>
                            <div class="table-row" v-if="row.mark === 1"><img src="./../../assets/img/zf.png" alt="">支付宝</div>
                            <div class="table-row" v-if="row.mark === 2"><img src="./../../assets/img/pay2.png" alt="">payoneer</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="收款人" prop="payee"></el-table-column>
                    <el-table-column label="收款账号" prop="account"></el-table-column>
                    <el-table-column label="操作" width="260">
                        <template slot-scope="{row}">
                            <!--<el-button type="success" size="mini">设为默认</el-button>-->
                            <el-button type="warning" size="mini" @click="editShow(row)">编辑</el-button>
                            <el-button type="danger" size="mini" @click="withdrawDel(row.id)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="货币" name="third">
                <el-table :data="moneyData[0]" border>
                    <el-table-column label="货币名称" prop="name"></el-table-column>
                    <el-table-column label="货币名称" prop="coin_name"></el-table-column>
                    <el-table-column label="汇率(100人民币)" prop="ratio"></el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="{row}">
                            <el-tag v-if="moneyData[1] === row.name" type="primary">当前使用货币</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="{row}">
                            <el-button type="success" size="mini" @click="setMoney(row.id)">选择为当前使用货币</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="密码修改" name="fourth">
                <el-form label-position="right" label-width="120px">
                    <el-form-item label="旧密码：">
                        <el-input type="password" v-model="psdForm.old_password" placeholder="请输入旧密码" style="width: 220px;"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码：">
                        <el-input type="password" v-model="psdForm.new_password" placeholder="请输入新密码" style="width: 220px;"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码：">
                        <el-input type="password" v-model="psdForm.new_password1" placeholder="请确认新密码" style="width: 220px;"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" :loading="loading" @click="changePassword">确认</el-button>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
        </el-tabs>
        <el-dialog :title="`${payId?'编辑':'新增'}收款方式`" :close-on-click-modal="false" :visible.sync="showAddPay" width="400px">
            <el-form label-width="80px" label-position="right">
                <el-form-item label="收款方式">
                    <el-select v-model="payForm.mark">
                        <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="payForm.mark===0" label="收款银行">
                    <el-input style="width: 220px;" placeholder="请输入收款银行" v-model="payForm.bank_of_deposit"></el-input>
                </el-form-item>
                <el-form-item label="收款人">
                    <el-input style="width: 220px;" placeholder="请输入收款人" v-model="payForm.payee"></el-input>
                </el-form-item>
                <el-form-item label="收款账户">
                    <el-input style="width: 220px;" placeholder="请输入收款账户" v-model="payForm.account"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button v-if="payId" :loading="loading" type="primary" @click="withdrawEdit">保存</el-button>
                    <el-button v-else :loading="loading" type="primary" @click="withdrawAdd">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <input @change="uploadImage" ref="file" type="file" hidden>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import {delToast} from '@/utlis/decorators'

    export default {
        name: "userCenter",
        data() {
            return {
                showAddPay: false,
                loading: false,
                activeName: 'first',
                sexList: [
                    {id: 1, name: '男'},
                    {id: 2, name: '女'},
                    {id: 0, name: '保密'},
                ],
                userForm: {},
                payTypeList: [],
                typeList: [
                    {id: 0, name: '银行卡'},
                    {id: 1, name: '支付宝'},
                    {id: 2, name: 'payoneer'},
                ],
                payId: '',
                payForm:{
                    payee: '',
                    mark: 0,
                    account: '',
                    bank_of_deposit: ''
                },
                moneyData: [],
                psdForm:{
                    old_password: '',
                    new_password: '',
                    new_password1: ''
                }
            }
        },
        computed: {
            ...mapState(['userInfo'])
        },
        watch: {
            'userInfo.detail': {
                handler(newVal) {
                    if(newVal){
                        this.userForm = {...newVal}
                    }
                },
                deep: true,
                immediate: true
            }
        },
        created() {
            this.fundsIndex();
            this.moneySelect();
        },
        methods: {
            async fundsIndex(){
                let [e, data] = await this.$api.fundsIndexApi();
                if(data.code === 200){
                    this.payTypeList = data.result;
                }
            },
            async withdrawAdd(){
                this.loading = true;
                let [e, data] = await this.$api.withdrawAddApi(this.payForm);
                this.loading = false;
                if(data.code === 200){
                    this.showAddPay = false;
                    this.$message.success('提交成功！');
                    this.fundsIndex();
                }else {
                    this.$message.warning(data.error);
                }
            },
            async withdrawEdit(){
                this.loading = true;
                let [e, data] = await this.$api.withdrawEditApi({id: this.payId, ...this.payForm});
                this.loading = false;
                if(data.code === 200){
                    this.showAddPay = false;
                    this.$message.success('保存成功！');
                    this.fundsIndex();
                }else {
                    this.$message.warning(data.error);
                }
            },
            @delToast('此操作将永久删除该支付方式，是否继续？')
            async withdrawDel(id){
                let [e, data] = await this.$api.withdrawDelApi({id})
                if(data.code === 200){
                    this.$message.success('删除成功！');
                    this.fundsIndex();
                }else{
                    this.$message.warning(data.error);
                }
            },
            payAddShow(){
                this.payId = '';
                this.payForm.payee = '';
                this.payForm.mark = 0;
                this.payForm.account = '';
                this.payForm.bank_of_deposit = '';
                this.showAddPay = true;
            },
            editShow({id, payee, mark, account, bank_of_deposit}){
                this.payId = id;
                this.payForm.payee = payee;
                this.payForm.mark = mark;
                this.payForm.account = account;
                this.payForm.bank_of_deposit = bank_of_deposit;
                this.showAddPay = true;
            },
            async moneySelect(){
                let [e, data] = await this.$api.moneySelectApi();
                if(data.code === 200){
                    this.moneyData = data.result;
                }
            },
            @delToast('是否使用当前货币？')
            async setMoney(id){
                let [e, data] = await this.$api.setMoneyApi({id});
                if(data.code === 200){
                    this.moneySelect();
                    this.$message.success('设置成功！');
                }else{
                    this.$message.warning(data.error);
                }
            },
            async changePassword(){
                if(!this.psdForm.new_password || !this.psdForm.old_password){
                    return this.$message.warning('请输入密码！')
                }
                if(this.psdForm.new_password!==this.psdForm.new_password1){
                    return this.$message.warning('两次密码不一致！')
                }
                this.loading = true;
                let [e, data] = await this.$api.changePasswordApi(this.psdForm)
                this.loading = false;
                if(data.status){
                    this.psdForm.old_password = '';
                    this.psdForm.new_password = '';
                    this.psdForm.new_password1 = '';
                    this.$message.success('密码修改成功！将于下次登录生效。');
                }else {
                    this.$message.warning(data.msg);
                }
            },
            async uploadImage(e){
                let file = e.target.files[0];
                let form = new FormData();
                form.append('image', file);
                let [err, data] = await this.$api.uploadImageApi(form)
                if(data.code === 200){
                    this.userForm.portrait = data.result;
                }
            },
            selectFile(){
                this.$refs.file.click();
            },
            async datumEdit(){
                this.loading = true;
                let [e, data] = await this.$api.datumEditApi(this.userForm);
                this.loading = false;
                if(data.status){
                    this.getUserInfo();
                    this.$message.success('保存成功！');
                }else{
                    this.$message.warning(data.msg);
                }
            },
            async getUserInfo(){
                let [e, data] = await this.$api.getUserInfoApi();
                if(e) return;
                this.$store.commit('saveUserInfo', data.result)
            },
            async changePhone(){
                try{
                    let val = await this.$prompt('请输入手机号', '手机号输入', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        closeOnClickModal: false,
                        inputValidator(item) {
                            let reg = /^1[3456789]\d{9}$/;
                            return reg.test(item)
                        },
                        inputErrorMessage: '请输入正确手机号！'
                    })
                    this.userForm.mobile = val.value;
                }catch (e) {

                }

            }
        },
    }
</script>

<style scoped lang="less">
    .table-row{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        line-height: 1;
        img{
            width: 20px;
            height: 20px;
            margin-right: 4px;
            object-fit: contain;
        }
    }
</style>
